@if (link || externalLink) {
  <myre-link
    [externalLink]="externalLink"
    [routerLink]="link"
    [queryParams]="queryParams"
    [routerLinkActiveOptions]="routerLinkActiveOptions"
    [aria-label]="ariaLabel"
    [useLinkStyle]="useLinkStyle"
    (isRouterLinkActive)="_routerLinkActive($event)"
  >
    <ng-container *ngTemplateOutlet="content" />
  </myre-link>
} @else {
  <div
    myrePreventDoubleClick
    class="content"
    role="button"
    tabindex="0"
    [class.link-style]="useLinkStyle"
    [attr.aria-label]="ariaLabel"
    (onClick)="clickEmitter.emit($event)"
  >
    <ng-container *ngTemplateOutlet="content" />
  </div>
}

<ng-template #content>
  <ng-content />
</ng-template>
